/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import sortBy from 'lodash/sortBy';
import {
  Table,
  TableColumn,
  TableHeaderColumn,
} from '@alefeducation/ui-elements-library-core';
import AssignmentContext from '../../../common/AssignmentContext/AssignmentContext';
import { filterBySelectedTeam } from '../../helpers';
import { useStudentListContext } from '../StudentListContext';
import { useCommonSectionItemElements } from '../useCommonSectionItemElements';
import {
  emptyColumn,
  evaluationColumn,
  fileColumn,
  resubmissionColumn,
  studentColumn,
  submissionDateColumn,
} from './commonStudentSectionColumns';
import { NewStudentListSection } from './StudentListSection/NewStudentListSection';
import { BulkUnlock } from './NewPendingSubmissionSection';
import { actionColumnWidth } from './constants';

export const NewPendingEvaluationSection = () => {
  const { t } = useTranslation();
  const {
    groupedSubmissions,
    onViewStudent,
    attachmentRequired,
    commentRequired,
    isLockingOfAssignmentEnabled,
    dueOn,
  } = useStudentListContext();
  const isSubmissionRequired = attachmentRequired || commentRequired;

  const {
    filters: { selectedTeamMembersIds, selectedTeamFilter },
  } = useContext(AssignmentContext);

  let { pendingEvaluation } = groupedSubmissions;

  pendingEvaluation =
    pendingEvaluation &&
    filterBySelectedTeam(
      selectedTeamFilter,
      selectedTeamMembersIds,
      pendingEvaluation,
    );

  const sectionItems =
    pendingEvaluation &&
    sortBy(pendingEvaluation, ({ student }) => student.name).map(
      ({ student, submission, resubmission }) => ({
        ...student,
        submission,
        resubmission,
      }),
    );

  const showBulkUnlock =
    isLockingOfAssignmentEnabled &&
    !isSubmissionRequired &&
    pendingEvaluation &&
    pendingEvaluation.length;

  const sectionItemsTable =
    pendingEvaluation.length > 0 ? (
      <Table
        rows={sectionItems}
        columns={[
          studentColumn(t),
          { ...submissionDateColumn(dueOn, t) },
          {
            ...fileColumn(attachmentRequired, t, '160px', 'pending-evaluation'),
          },
          { ...resubmissionColumn(t) },
          { ...emptyColumn() },
          { ...evaluationColumn(t, '364px') },
          {
            key: 'id',
            name: t('Actions'),
            renderColumn: ({ row }) => {
              const {
                feedbackField,
                requestResubmitField,
                viewIcon,
                newUnAssignHandle,
              } = useCommonSectionItemElements(row, row.submission);
              return (
                <TableColumn
                  row={row}
                  isFirstColumn={false}
                  className="actions-cell"
                >
                  <div className="actions-container">
                    {requestResubmitField}
                    {feedbackField}
                    {!isSubmissionRequired && newUnAssignHandle}
                    {viewIcon(row, onViewStudent)}
                  </div>
                </TableColumn>
              );
            },
            renderHeaderColumn: rows => (
              <TableHeaderColumn
                isFirstColumn={false}
                rows={rows}
                width={actionColumnWidth}
              >
                <div className="col-heading">{t('Actions')}</div>
              </TableHeaderColumn>
            ),
            alignText: 'right',
            width: actionColumnWidth,
            height: '44px',
          },
        ]}
        isSticky={true}
        translationKeys={t}
      />
    ) : null;
  return (
    <NewStudentListSection
      data-testid="pending-evaluation-section"
      submissions={pendingEvaluation}
      sectionName={t('Pending Evaluation')}
      labelColor={'#1A9692'}
      groupControlItems={
        <BulkUnlock
          showBulkUnlock={showBulkUnlock}
          students={pendingEvaluation}
        />
      }
      sectionItems={sectionItemsTable}
    />
  );
};
